export default __webpack_public_path__ + "static/media/CE-Info.ebba3d40.svg";